(ns dre.components.error-view
  (:require
    [dre.components.icon :refer [svg]]
    [dre.i18n.views :refer [tr]]
    [dre.utils.bem :as bem]))


(def component-name :error-view)


(defn error-view
  [error]
  [:div
   {:class component-name}
   [:div
    {:class (bem/be component-name :icon)}
    [svg :common :warning]]
   [:h3 [tr "Some parts of the app don't work properly. We filed the error."]]
   [:div
    {:class (bem/be component-name :message)}
    error]])
